import { render, staticRenderFns } from "./PaySchedulesFailedSalaries.vue?vue&type=template&id=0d7772ad&"
import script from "./PaySchedulesFailedSalaries.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaySchedulesFailedSalaries.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports